import { JensiatEnum } from 'Feature/Common/Common/Types/Enums/JensiatEnum';

import AddressInitialState from './InitialStates/AddressInitialState';
import BimehMarkaziInitialStateSodoor from './InitialStates/BimehMarkaziInitialStateSodoor';
import BimehNamehInitialStateEstelam from './InitialStates/BimehNamehInitialStateEstelam';
import { BimehNamehInitialStateSodoor } from './InitialStates/BimehNamehInitialStateSodoor';
import SherkatBimehGhablInitialState from './InitialStates/SherkatBimehGhablInitialState';
import VehicleInfoInitialStateEstelam from './InitialStates/VehicleInfoInitialStateEstelam';
import { VehicleInfoInitialStateSodoor } from './InitialStates/VehicleInfoInitialStateSodoor';
import SodoorBimehNamehByPelakSliceType from './SodoorBimehNamehByPelakSliceType';

const SodoorBimehNamehByPelakInitialState: SodoorBimehNamehByPelakSliceType = {
  getCodeShenasehPardakhtShakhsSalesCommand: {
    bimehNameh: BimehNamehInitialStateSodoor,
    ranandehHa: [],
    tarafHayeGharardad: [],
    address: AddressInitialState,
    vasilehNaghlieh: VehicleInfoInitialStateSodoor,
    bimehMarkazi: BimehMarkaziInitialStateSodoor,
    sherkatBimehGhabl: SherkatBimehGhablInitialState,
    discountCode: '',
    wepodUserId: 0,
  },

  isMablaghKharidBimehNamehMoreThanHaghBimeh: false,

  isSuccess: false,
  StepOneData: null,
  StepTwoData: null,
  StepThreeData: null,
  StepFourData: null,
  StepFiveData: null,

  needToEdit: false,

  estelamBimehMarkazi: {
    loading: false,
    data: null,
  },
  moddatHayeBimehNameh: {
    loading: false,
    data: [],
  },
  estelamCommand: {
    vehicleInfo: VehicleInfoInitialStateEstelam,
    bimehNameh: BimehNamehInitialStateEstelam,

    shadowFields: {
      vaziatBimehNamehGhabli: true,
      khesaratDaryaftKardehEed: false,
    },
  },
  estelamSabtAhval: {
    loading: false,
    data: {
      naam: '',
      naamKhanevadegi: '',
      jensiat: JensiatEnum.MARD,
      tarikhTavallod: new Date(),
    },
  },
  getAddressWithPostCode: {
    loading: false,
    data: null,
  },
  noePelak: {
    loading: false,
    data: undefined,
  },
  harfHayePelak: {
    loading: false,
    data: [],
  },
  isCommandFilled: false,
  showConfirmFromUser: false,
  estelamResult: {
    loading: false,
    loaded: false,
    data: null,
  },
  tarafHayeGharardad: [],

  anvaeVasilehNaghleyeh: {
    loading: false,
    data: [],
  },
  tarhTakhfif: {
    loading: false,
    data: [],
  },
  taahodatSalesMali: {
    loading: false,
    data: [],
  },
  moredEstefadehHayeKhodro: {
    loading: false,
    data: [],
  },
  brandHa: {
    loading: false,
    data: [],
  },
  tipHa: {
    loading: false,
    data: [],
  },
  anvaePelak: {
    loading: false,
    data: [],
  },

  rangHa: {
    loading: false,
    data: [],
  },
  taahodatSalesSarneshin: {
    loading: false,
    data: undefined,
  },
  taahodatSalesJaani: {
    loading: false,
    data: undefined,
  },

  countries: {
    loading: false,
    data: [],
  },

  anvaeSherkatBimeh: {
    loading: false,
    data: [],
  },

  getCodeShenasehPardakhtShakhsSalesResult: {
    loading: false,
    data: null,
  },

  serialPelaks: {
    loading: false,
    data: [],
  },

  addToOrderResponse: {
    loading: false,
  },
  sodoorWizard: {
    begin: 1,
    end: 8,
    current: 1,
  },
  niazBeEstelamBimehMarkazi: false,

  takhfifHayeJarimehSales: {
    loading: false,
    data: [],
  },

  takhfifHayeJarimehSarneshin: {
    loading: false,
    data: [],
  },

  bimehNamehExpireDateMaxDay: {
    loading: false,
  },

  haghBimehPardakhti: 0,

  tamdidInfo: {
    loading: false,
    data: null,
  },

  isDuplicateBimehNamehInOrder: {
    loading: false,
    data: null,
  },
};

export default SodoorBimehNamehByPelakInitialState;
